module.exports = __webpack_public_path__ + "assets/bc98d3cc1b52b22550b863b7cf4b05e4.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/coins/Bet_3.mp3
 ** module id = 362
 ** module chunks = 0
 **/